import React from "react";
import { motion } from "framer-motion";

const Testimonials = () => {
  const transformations = [
    {
      icon: "✔",
      text: "You stop doubting your ability to create original music"
    },
    {
      icon: "✔",
      text: "You finish songs instead of leaving ideas unfinished"
    },
    {
      icon: "✔",
      text: "You understand music practically — without heavy theory"
    },
    {
      icon: "✔",
      text: "You create and release your own original song"
    },
    {
      icon: "✔",
      text: "You start seeing yourself as an original Indie Artist"
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What Changes When You Follow the Right System
          </h2>
          <div className="w-24 h-1 bg-purple-600 mx-auto"></div>
        </motion.div>

        <div className="space-y-6">
          {transformations.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.02, x: 10 }}
              className="bg-gradient-to-r from-purple-50 to-blue-50 p-6 rounded-xl shadow-lg flex items-center gap-4"
            >
              <span className="text-4xl text-purple-600 font-bold">{item.icon}</span>
              <p className="text-xl md:text-2xl font-semibold text-gray-800">{item.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
